import "react-app-polyfill/ie11";
import "react-app-polyfill/stable";
import React from "react";
import App from "./App";
import { createRoot } from "react-dom/client";
import { BrowserRouter } from "react-router-dom";

function renderRoot() {
  const container = document.getElementById("root");
  const root = createRoot(container);
  root.render(
    <BrowserRouter>
      <App />
    </BrowserRouter>
  );
}

if (window._env_.NODE_ENV !== "production" && module.hot) {
  module.hot.accept("./App", renderRoot);
}

window.addEventListener("load", renderRoot);
